import axios from "./configs/axiosConfig";

// Potential Agreements (#418): invoice lines that look like a JB plan sale but never became an
// agreement. dealerId 0 is every dealer, and the API allows that only for an admin. params pass
// straight through as the query string ({ include: "other" } adds the non-JB tier).
export const getPotentialAgreements = async (dealerId, params) =>
  axios.get(`agreements/potential/dealer/${dealerId}`, { params });

export const acceptPotentialAgreement = async (id, productCode) =>
  axios.post(`agreements/potential/${id}/accept`, { productCode });

export const dismissPotentialAgreements = async (ids) =>
  axios.post("agreements/potential/dismiss", { ids });
